import react, { useCallback, useState, useEffect } from "react";
import reactLogo from "./assets/react.svg";
import viteLogo from "/vite.svg";
import "./App.css";
import QRMenu from "./views/QRMenu";
import Cookies from "js-cookie";

function App() {
  const [count, setCount] = useState(0);
  const isDark = Cookies.get("theme");
  const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

  const handleSystemMode = useCallback(() => {
    if (mediaQuery.matches) {
      document.documentElement.classList.add("dark");
      document.documentElement.classList.remove("light");
    } else {
      document.documentElement.classList.add("light");
      document.documentElement.classList.remove("dark");
    }
  }, [isDark, mediaQuery]);

  useEffect(() => {
    if (isDark === "system") {
      mediaQuery.addEventListener("change", handleSystemMode);
      handleSystemMode();
      return () => {
        mediaQuery.removeEventListener("change", handleSystemMode);
      };
    } else {
      if (isDark === "dark") {
        document.body.classList.add("dark");
        document.body.classList.remove("light");
      } else if (isDark === "light") {
        document.body.classList.add("light");
        document.body.classList.remove("dark");
      }
    }
  }, [isDark, handleSystemMode]);
  useEffect(() => {
    if (!Cookies.get("theme")) {
      Cookies.set("theme", "system");
      mediaQuery.addEventListener("change", handleSystemMode);
      handleSystemMode();
      return () => {
        mediaQuery.removeEventListener("change", handleSystemMode);
      };
    }
  }, []);

  return (
    // <div className="flex items-center justify-center min-h-screen bg-gray-100">
    //   <div className="container mx-auto px-4 sm:px-6 lg:px-8">
    // <div className="bg-white text-base dark:bg-slate-900 text-slate-900 dark:text-slate-200">
    //   <QRMenu />
    // </div>
 <div className="fixed inset-0 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-200 overflow-hidden">
  <QRMenu />
</div>
    // </div>
  );
}

export default App;
